import { Outlet, useNavigate } from 'react-router';

import { Auth0Provider } from '@auth0/auth0-react';
import { audience, auth0CacheLocation, clientId, domain, redirectUri, scope } from 'appConstants';

export default function Auth0ProviderWithNavigate() {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      cacheLocation={auth0CacheLocation}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience,
        scope,
      }}
      useRefreshTokensFallback
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
    >
      <Outlet />
    </Auth0Provider>
  );
}
